import { useRouterState } from '@tanstack/react-router';

/** True while a report is open for editing (not the list, not "new report"). */
export function useInReportEditor(): boolean {
  const path = useRouterState({ select: (r) => r.location.pathname });
  return /^\/reports\/(?!new$)[^/]+/.test(path);
}
